import { Divider, Grid, GridItem, Heading, Text } from "@chakra-ui/react";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";

import { HTTPError, useKy } from "src/common/ky";
import { Loading } from "src/common/Loading";
import PageHeaderError from "src/common/PageHeaderError";
import { formatPhoneNumber } from "src/common/phone-numbers";
import { DealerFinancials as DealerFinancialsType } from "src/common/types";
import { PageContent } from "src/layout/PageContent";

export const DealerOrganizationFinancials = () => {
  const { id } = useParams<"id">();
  const ky = useKy();
  const query = useQuery<DealerFinancialsType, HTTPError>(
    `DEALER_FINANCIALS:${id}`,
    () => ky.get(`dealer-financials/${id}`).json<DealerFinancialsType>()
  );

  if (query.isError) {
    return (
      <PageHeaderError
        statusCode={query.error.response.status}
        statusText={query.error.response.statusText}
      />
    );
  }

  if (query.isLoading || !query.isSuccess) {
    return <Loading />;
  }

  const data = query.data;

  return (
    <>
      <PageContent>
        <Grid templateColumns={"repeat(2, 1fr)"} gap={4}>
          <GridItem colSpan={2}>
            <Heading size="md">Billing Information</Heading>
          </GridItem>

          <GridItem colSpan={2}>
            <Divider />
          </GridItem>

          <GridItem>
            <Text>Name of Business</Text>
          </GridItem>
          <GridItem>
            <Text>{data.businessName || "-"}</Text>
          </GridItem>

          <GridItem>
            <Text>License Number</Text>
          </GridItem>
          <GridItem>
            <Text>{data.licenseNumber || "-"}</Text>
          </GridItem>

          <GridItem>
            <Text>Business is Tax Exempt</Text>
          </GridItem>

          <GridItem>
            <Text>{data.isTaxExempt ? "Yes" : "No"}</Text>
          </GridItem>

          <GridItem>
            <Text>Tax I.D. Number</Text>
          </GridItem>

          <GridItem>
            <Text>{data.taxIdNumber || "-"}</Text>
          </GridItem>
        </Grid>
      </PageContent>

      <PageContent>
        <Grid templateColumns={"repeat(2, 1fr)"} gap={4}>
          <GridItem colSpan={2}>
            <Heading size={"md"}>Billing Contact</Heading>
          </GridItem>

          <GridItem colSpan={2}>
            <Divider />
          </GridItem>

          <GridItem>
            <Text>Name</Text>
          </GridItem>

          <GridItem>
            <Text>{data.billingContactName || "-"}</Text>
          </GridItem>

          <GridItem>
            <Text>Phone</Text>
          </GridItem>

          <GridItem>
            <Text>{formatPhoneNumber(data.billingContactPhone)}</Text>
          </GridItem>

          <GridItem>
            <Text>Email</Text>
          </GridItem>

          <GridItem>
            <Text>{data.billingContactEmail || "-"}</Text>
          </GridItem>

          <GridItem>
            <Text>Billing Address</Text>
          </GridItem>

          <GridItem>
            <Text>{data.billingContactAddress || "-"}</Text>
          </GridItem>
          <GridItem>
            <Text>City</Text>
          </GridItem>

          <GridItem>
            <Text>{data.billingContactCity || "-"}</Text>
          </GridItem>
          <GridItem>
            <Text>State</Text>
          </GridItem>

          <GridItem>
            <Text>{data.billingContactState || "-"}</Text>
          </GridItem>
          <GridItem>
            <Text>Zip Code</Text>
          </GridItem>

          <GridItem>
            <Text>{data.billingContactZipCode || "-"}</Text>
          </GridItem>

          <GridItem>
            <Text>Invoicing Method</Text>
          </GridItem>

          <GridItem>
            <Text>{data.invoicingMethod || "-"}</Text>
          </GridItem>
        </Grid>
      </PageContent>
    </>
  );
};
